import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/ForgetPass.css";
import { API_URL } from '../config';

// 1. Usando template literals (comillas invertidas)
const API = `${API_URL}/api`;


const ResetPasswordConfirm: React.FC = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const [valid, setValid] = useState<boolean | null>(null);
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const validate = async () => {
      try {
        const r = await axios.get(`${API}/auth/password-reset/validate/`, {
          params: { uid, token },
        });
        setValid(r.data.valid);
      } catch {
        setValid(false);
      }
    };
    validate();
  }, [uid, token]);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMsg("");

    if (p1.length < 8) {
      setMsg("La contraseña debe tener al menos 8 caracteres.");
      return;
    }
    if (p1 !== p2) {
      setMsg("Las contraseñas no coinciden.");
      return;
    }

    try {
      setLoading(true);
      await axios.post(`${API}/auth/password-reset/confirm/`, {
        uid,
        token,
        new_password: p1,
      });
      navigate("/login");
    } catch (err: any) {
      setMsg(err?.response?.data?.detail || "Error al actualizar la contraseña.");
    } finally {
      setLoading(false);
    }
  };

  if (valid === null) {
    return (
      <div className="fp-wrap">
        <div className="fp-card">
          <div className="fp-header">
            <h2 className="fp-title">Validando enlace…</h2>
            <p className="fp-subtitle">Por favor, espera un momento.</p>
          </div>
        </div>
      </div>
    );
  }

  if (!valid) {
    return (
      <div className="fp-wrap">
        <div className="fp-card">
          <div className="fp-header">
            <h2 className="fp-title">El enlace no es válido o ha expirado.</h2>
            <p className="fp-subtitle">Vuelve a solicitar un nuevo enlace desde “¿Olvidaste tu clave?”.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fp-wrap">
      <div className="fp-card">
        <div className="fp-header">
          <h2 className="fp-title">Define tu nueva contraseña</h2>
          <p className="fp-subtitle">Crea una contraseña segura para tu cuenta.</p>
        </div>

        <form className="fp-form" onSubmit={submit}>
          <label htmlFor="newpass1" className="fp-label">Nueva contraseña</label>
          <input
            id="newpass1"
            className="fp-input"
            type="password"
            placeholder="Mínimo 8 caracteres"
            value={p1}
            onChange={(e) => setP1(e.target.value)}
            autoComplete="new-password"
            required
          />

          <label htmlFor="newpass2" className="fp-label">Repite la contraseña</label>
          <input
            id="newpass2"
            className="fp-input"
            type="password"
            placeholder="Vuelve a escribirla"
            value={p2}
            onChange={(e) => setP2(e.target.value)}
            autoComplete="new-password"
            required
          />

          {msg && <div className="fp-alert fp-alert-error">{msg}</div>}

          <button className="fp-btn" type="submit" disabled={loading}>
            {loading ? "Guardando…" : "Guardar"}
          </button>

          <p className="fp-help">Evita usar tu nombre, correo o patrones simples.</p>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordConfirm;
